import React from 'react';
import './footer.css';


const Footer = () =>{

    return(
<div className="footer">
    <small>Made with ♥ by Jesica Velazquez</small>
</div>

    )

}

export default Footer;